export const INTERNAL_SERVER_ERROR = 'Something went wrong. Please try again or contact support';
export const DEFAULT_ERROR_MESSAGE = {'status': 'FAILED', 'responseMessage': INTERNAL_SERVER_ERROR};
export const NO_RECORDS_FOUND_ERROR_MESSAGE = 'No records were found.';
export const ACCOUNT_ID_NOT_SET_ERROR_MESSAGE = 'Opportunity account id is not set';
export const MISSING_FORM_INPUT_MESSAGE = 'Empty or Missing {0}';
export const MISSING_FORM_FIELD = "Missing {0}";
export const NO_MODULES_CONFIGURED_MESSAGE = "Your account is not configured with permissions to access any modules. Please contact I.T support to assist.";
export const FAILED_TO_LOAD_MESSAGE = "Failed to load {0}. Please reload the page or contact support.";
